 import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DiscountOfferEntity } from '../../domain/entities/DiscountOfferEntity'
import type { DiscountAdminDto } from '@/backend/market'
export class DiscountOfferModel extends DiscountOfferEntity {
  startDate?: Date
  endDate?: Date
  constructor(dataDto: DiscountAdminDto) {
    super()
    mapEntityProperties<DiscountOfferEntity>(this, dataDto, {
      map: {
        start: dataDto.startDate ? (dataDto.startDate) : undefined,
        end: dataDto.endDate ? (dataDto.endDate) : undefined,
        branch:{
        name: dataDto.branchName,
        id: dataDto.branchId
       }
      }
    })
  }
}
